<template>
    <v-autocomplete
        :label="label"
        :items="sortedRoutes"
        :item-text="(x) => `${x.name} (${x.path})`"
        item-value="path"
        :value="value"
        @input="$emit('input', $event)"
        :clearable="clearable"
    />
</template>

<script>
  export default {
    name: 'zoezi-page-setting',

    props: ['value', 'label', 'clearable', 'routeFilter', 'props'],

    computed: {
        filteredRoutes() {
          let routes = this.$root.siteconfig.routes;
          if (this.routeFilter) {
            routes = routes.filter(r => this.routeFilter(r, this.props));
          }

          return routes;
        },
        sortedRoutes() {
            return this.filteredRoutes.map(r => r.props).sort((a, b) => a.name.localeCompare(b.name));
        }
    }
  }
</script>